import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../../../../types'
import { CmsConverterService, defaultTextInput } from '../../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TimelineItemConverter extends CmsConverterService<TimelineItemData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      text: formData?.st_text ?? defaultTextInput,
      time: formData?.st_time ?? defaultTextInput
    }
  }
}

export const TIMELINE_ITEM_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TimelineItemData>>('TimelineItemConverter')

export interface TimelineItemData extends ConvertedComponentData {
  text: TextInput;
  time: TextInput;
}
